import p5 from "p5";
export const withP5DrawingLibrary = (function withP5DrawingLibrary() {
  const sketch = (setupCb, drawCb, that, p) => {
    // TODO not entirely sure about this here
    p.setup = () => setupCb(p);
    p.draw = () => drawCb(p);
    that._p = p;
  };

  function createLibrary(containerElement, setupCb, drawCb) {
    this.drawingLibrary_ = new p5(
      sketch.bind(this, setupCb, drawCb, this),
      containerElement
    );
  }

  function destroyLibrary() {
    // if _penAndPencilCanvas, _cirlceMask, _branchMask then remove
    if (this.drawingLibrary_._penAndPencilCanvas)
      this.drawingLibrary_._penAndPencilCanvas.remove();
    this.drawingLibrary_._penAndPencilCanvas = null;
    if (this.drawingLibrary_._circleMask)
      this.drawingLibrary_._circleMask.remove();
    this.drawingLibrary_._circleMask = null;
    if (this.drawingLibrary_._branchMask)
      this.drawingLibrary_._branchMask.remove();
    this.drawingLibrary_._branchMask = null;

    // foregorund and backgroundimage
    if (this.drawingLibrary_._foregroundImage)
      this.drawingLibrary_._foregroundImage = null;
    if (this.drawingLibrary_._backgroundImage)
      this.drawingLibrary_._backgroundImage = null;

    this.drawingLibrary_._canvas = null;
    this.drawingLibrary_.remove();
    this.drawingLibrary_ = null;
    this._p = null;
    // delete all canvas in the dom
    const canvases = document.getElementsByTagName("canvas");
    for (let i = 0; i < canvases.length; i++) {
      canvases[i].remove();
    }
  }

  function drawingLibrary() {
    return this.drawingLibrary_;
  }

  // Reveal and hoist common drawingLibrary components
  function width() {
    return this.drawingLibrary().width;
  }

  function height() {
    return this.drawingLibrary().height;
  }

  function loadImage(...args) {
    return this.drawingLibrary().loadImage(...args);
  }

  return {
    createLibrary,
    destroyLibrary,
    drawingLibrary,
    width,
    height,
    loadImage,
  };
})();
